<template>
  <div id="app" class="tracking-wider" :style="{ backgroundColor: bgColor }">
    <router-view />
  </div>
</template>

<script>
import Login from './components/Login.vue';

export default {
  name: 'App',
  computed: {
    bgColor() {
      return process.env.VUE_APP_BG_COLOR || '';
    },
  },
  components: {
    Login,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  height: 100%;
}
</style>
